import { IsActiveMatchOptions } from '@angular/router';

/**
 * Exact path match that ignores sticky query params (`orgId`, `view`, …).
 * Use for leaf destinations that must not light on child routes
 * (e.g. `/organisation` vs `/organisation/members`).
 *
 * Prefer this over the legacy `{ exact: true }` shorthand — that form
 * also requires an exact query-string match, so sticky params leave the
 * nav item unselected.
 */
export const EXACT_PATH_ACTIVE_MATCH: IsActiveMatchOptions = {
  paths: 'exact',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};

/**
 * Prefix match (path or descendant) that ignores sticky query params.
 * Used by section headers that expand when any child destination is open.
 */
export const SUBSET_PATH_ACTIVE_MATCH: IsActiveMatchOptions = {
  paths: 'subset',
  queryParams: 'ignored',
  fragment: 'ignored',
  matrixParams: 'ignored',
};
